import { useCallback, useState } from 'react';
import DefinedDrawers from './defined-drawers.ts';

// ---

export default function useDrawers() {
	const [shownDrawer, setShownDrawer] = useState<DefinedDrawers | null>(null);

	const toggleDrawer = useCallback(
		(drawerToToggle: DefinedDrawers) => {
			if (drawerToToggle === shownDrawer) {
				setShownDrawer(null);
				return;
			}

			setShownDrawer(drawerToToggle);
		},
		[shownDrawer]
	);

	return {
		shownDrawer,
		toggleDrawer,
	};
}
